// import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import { Button, Divider, Popover, Radio, Row, Space } from "antd";
import { Dispatch, memo, SetStateAction, useState } from "react";
import { ReactComponent as SorterIcon } from "assets/svgs/sort_icon.svg";
import { SorterInterface } from "../../interfaces/SorterInterface.d";
// import { SorterType } from "../../../dashboard/redux/slices/cruds/citiesSlice";
import styles from "./styles.module.scss";

type sorterTypes = {
  sorter: SorterInterface;
  sortersName: string[];
  setSorter: (payload: SorterInterface) => void;
  selectionMode?: boolean;
};
/**
 * @description a component that resposible for making sort request on existing url by passing to its params
 * the sorter state and the names that we want to sort on it and the dispatcher function (setSorter) that will edit the
 * url state on submit  finally a selection mode prop to disable the filter if true
 * @param {SorterInterface} sorter - the sorter state from redux slice usually
 * @param {string[]} sortersName - the array of names that we want to sort on
 * @param {Function} setSorter - the dispatcher fuction
 * @param {boolean} selectionMode - the prop to disable if true
 */
const Sorter = ({
  sorter,
  sortersName,
  setSorter,
  selectionMode = false,
}: sorterTypes) => {
  const [sorterState, setsorterState] = useState<"" | "-">(sorter.type);
  const [sorterTempName, setsorterTempName] = useState<string | null>(
    sorter.name
  );
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
    setsorterTempName(sorter.name);
    setsorterState(sorter.type);
  };
  let SorterContent = () => {
    return (
      <>
        <Row>
          <Radio.Group
            className={styles.radiogroup}
            value={sorterTempName}
            onChange={(e) => {
              setsorterTempName(e.target.value);
            }}
          >
            <Space direction="vertical">
              {sortersName.map((name) => {
                return <Radio value={name}>{name.toUpperCase()}</Radio>;
              })}
            </Space>
          </Radio.Group>
          <Divider type="vertical" className={styles.divider} />
          <Space direction="vertical" className={styles.space}>
            <Button
              className={`${styles.sortertype} ${
                sorterState === "" && styles.typeactive
              }`}
              type="ghost"
              size="small"
              onClick={() => {
                setsorterState("");
              }}
            >
              ASC
            </Button>
            <Button
              className={`${styles.sortertype} ${
                sorterState === "-" && styles.typeactive
              }`}
              type="ghost"
              size="small"
              onClick={() => {
                setsorterState("-");
              }}
            >
              DESC
            </Button>
          </Space>
        </Row>
        <br />
        <Row>
          <Button
            danger
            onClick={() => {
              setSorter({ name: null, type: "" });
              setOpen(false);
            }}
          >
            Reset
          </Button>
          <Button
            style={{ marginLeft: "auto" }}
            type="primary"
            onClick={() => {
              setSorter({ type: sorterState, name: sorterTempName });
              setOpen(false);
            }}
          >
            Ok
          </Button>
        </Row>
      </>
    );
  };
  return (
    <>
      {!selectionMode ? (
        <>
          <Popover
            content={<SorterContent />}
            // trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
            placement="bottomRight"
          >
            <SorterIcon
              className={`${styles.sortericon} ${
                (open || sorter?.name) && styles.active
              }`}
            />
          </Popover>
        </>
      ) : (
        <>
          <SorterIcon className={`${styles.sortericon} ${styles.disabled}`} />
        </>
      )}
    </>
  );
};

export default memo(Sorter);
